import { render } from "./CourseCards.vue?vue&type=template&id=e9cf06b0&scoped=true"
import script from "./CourseCards.vue?vue&type=script&lang=js"
export * from "./CourseCards.vue?vue&type=script&lang=js"

import "./CourseCards.vue?vue&type=style&index=0&id=e9cf06b0&scoped=true&lang=css"

import exportComponent from "C:\\Users\\s576427\\Supplemental\\Supplemental UI\\suppl-material-ui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e9cf06b0"]])

export default __exports__